import React from "react";
import {SpeechContext} from '../providers';

function useSpeech() {
    return React.useContext(SpeechContext);
}

export {useSpeech}
